var $b77a23040d0637b4$exports = {};
$b77a23040d0637b4$exports = {
    "collapse": `Contraer`,
    "columnResizer": `Redimensionador de columnas`,
    "drag": `Arrastrar`,
    "expand": `Ampliar`,
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`,
    "resizeColumn": `Cambiar el tama\xf1o de la columna`,
    "sortAscending": `Orden ascendente`,
    "sortDescending": `Orden descendente`
};


export {$b77a23040d0637b4$exports as default};
//# sourceMappingURL=es-ES.module.js.map
